import { useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex h-screen flex-col items-center justify-center bg-background-50 px-4 text-center">
      <span className="pointer-events-none select-none font-heading text-8xl font-black text-background-200 md:text-[12rem]">
        404
      </span>
      <div className="relative z-10 -mt-10">
        <h1 className="font-heading text-xl font-semibold text-foreground-950 md:text-2xl">
          This page has not been generated
        </h1>
        <p className="mt-2 text-sm text-foreground-600">{location.pathname}</p>
        <p className="mt-4 text-base text-foreground-500 md:text-lg">
          Tell me more about this page, so I can generate it
        </p>
      </div>
    </div>
  );
}